import { MinimalUser } from "interface/user"

export const NOTIFICATION_TYPES = [
	"ESCALATION_ASSIGNED",
	"ESCALATION_REASSIGNED",
	"ESCALATION_RESPONSE_ADDED",
	"ESCALATION_CLOSED",
	"ESCALATION_REOPENED",
	"ASSIGNEE_REMINDER_24H",
	"ASSIGNEE_REMINDER_48H",
	"OBSERVER_REMINDER_48H",
	"UNASSIGNED_AUTHOR_REMINDER",
] as const

type NotificationType = (typeof NOTIFICATION_TYPES)[number]

export const NOTIFICATION_CATEGORIES = ["assignment", "subscription"] as const

type NotificationCategory = (typeof NOTIFICATION_CATEGORIES)[number]

export const NOTIFICATION_FEED_STATUS = ["all", "unread"] as const

export type NotificationFeedStatus = (typeof NOTIFICATION_FEED_STATUS)[number]

export interface Notification {
	id: string
	type: NotificationType
	category: NotificationCategory
	escalationId: string
	patient: MinimalUser
	actor: MinimalUser | null
	previousAssignee?: MinimalUser
	newAssignee?: MinimalUser
	careOrgId: string | null
	isRead: boolean
	createdAt: string
}

export interface NotificationUnreadCount {
	unreadCount: number
}

export interface ChannelPreference {
	isAssignmentEnabled: boolean
	isSubscriptionEnabled: boolean
}

export interface NotificationPreferences {
	inApp: ChannelPreference
	email: ChannelPreference
	sms: ChannelPreference
	isSmsCapablePhoneOnFile: boolean
}

export type UpdateNotificationPreferencesPayload = Omit<
	NotificationPreferences,
	"isSmsCapablePhoneOnFile"
>
